<template>
  <div class="pdf-viewer-toolbar d-flex align-items-center justify-content-between flex-wrap">
    <div class="pdf-viewer-toolbar__meta d-flex align-items-center mb-2 mb-lg-0">
      <div class="pdf-viewer-toolbar__title text-truncate" :title="title">{{ title }}</div>
      <b-badge variant="light" class="ml-3">{{ Math.round(zoomLevel * 100) }}%</b-badge>
    </div>

    <div class="pdf-viewer-toolbar__actions d-flex align-items-center flex-wrap justify-content-end">
      <div class="d-flex align-items-center mr-3 mb-2 mb-lg-0">
        <b-button size="sm" variant="outline-secondary" :disabled="disabled || currentPage <= 1" @click="$emit('prev-page')">
          <i class="fas fa-chevron-left"></i>
        </b-button>

        <b-form-input
          class="mx-2 pdf-viewer-toolbar__page-input"
          type="number"
          :min="1"
          :max="Math.max(totalPages, 1)"
          :value="pageInput"
          @change="onJumpPage"
        />

        <span class="text-muted">/ {{ totalPages || 1 }}</span>

        <b-button
          size="sm"
          variant="outline-secondary"
          class="ml-2"
          :disabled="disabled || currentPage >= totalPages"
          @click="$emit('next-page')"
        >
          <i class="fas fa-chevron-right"></i>
        </b-button>
      </div>

      <div class="d-flex align-items-center mr-3 mb-2 mb-lg-0">
        <b-button size="sm" variant="outline-secondary" :disabled="disabled" @click="$emit('zoom-out')">
          <i class="fas fa-search-minus"></i>
        </b-button>
        <b-button size="sm" variant="outline-secondary" class="ml-2" :disabled="disabled" @click="$emit('zoom-in')">
          <i class="fas fa-search-plus"></i>
        </b-button>
        <b-button size="sm" variant="outline-secondary" class="ml-2" :disabled="disabled" @click="$emit('fit-width')">
          Fit width
        </b-button>
        <b-button size="sm" variant="outline-secondary" class="ml-2" :disabled="disabled" @click="$emit('rotate')">
          <i class="fas fa-redo"></i>
        </b-button>
      </div>

      <div class="d-flex align-items-center mb-2 mb-lg-0">
        <b-button
          v-if="canPrint"
          size="sm"
          variant="outline-secondary"
          class="mr-2"
          :disabled="disabled"
          @click="$emit('print')"
        >
          <i class="fas fa-print mr-1"></i>In
        </b-button>
        <b-button
          v-if="canDownload"
          size="sm"
          variant="primary"
          class="mr-2"
          :disabled="disabled"
          @click="$emit('download')"
        >
          <i class="fas fa-download mr-1"></i>Tải PDF
        </b-button>
        <b-button size="sm" variant="outline-dark" @click="$emit('close')">
          <i class="fas fa-times"></i>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PdfViewerToolbar',
  props: {
    title: {
      type: String,
      default: '',
    },
    currentPage: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    zoomLevel: {
      type: Number,
      required: true,
    },
    canDownload: {
      type: Boolean,
      default: false,
    },
    canPrint: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pageInput: this.currentPage,
    }
  },
  watch: {
    currentPage(nextValue) {
      this.pageInput = nextValue
    },
  },
  methods: {
    onJumpPage(event) {
      const page = Number(event.target.value || 1)
      this.$emit('jump-page', page)
    },
  },
}
</script>

<style lang="scss" scoped>
.pdf-viewer-toolbar {
  gap: 0.75rem;

  &__meta {
    min-width: 0;
  }

  &__title {
    max-width: 360px;
    font-weight: 600;
  }

  &__actions {
    gap: 0.5rem;
  }

  &__page-input {
    width: 84px;
  }
}
</style>
